import { render, staticRenderFns } from "./change-record-modal.vue?vue&type=template&id=07556173&scoped=true"
import script from "./change-record-modal.vue?vue&type=script&lang=js"
export * from "./change-record-modal.vue?vue&type=script&lang=js"
import style0 from "./change-record-modal.vue?vue&type=style&index=0&id=07556173&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07556173",
  null
  
)

export default component.exports